import React from "react";
import { Grid } from "@zendeskgarden/react-grid";
import { MD, XXL, XXXL, SM } from "@zendeskgarden/react-typography";
import { Skeleton } from "@zendeskgarden/react-loaders";

export default function SheetSkeleton() {
  return (
    <>
      {/* <Grid gutters="false"> */}
      <div className="flex justify-between h-[20px]">
        <Skeleton style={{ width: "100px" }} />

        <XXL className="flex justify-end">
          <Skeleton style={{ width: "40px", marginLeft: "auto" }} />
        </XXL>
      </div>
      {/* <div className="flex justify-between h-[12px] mt-[10px]">
        <Skeleton style={{ width: "100px" }} />

        <Skeleton style={{ width: "100px" }} />
      </div> */}
      <div className="h-[30px] mt-[30px]">
        <Skeleton />
      </div>
      <div className="h-[14px] mt-[60px]">
        <Skeleton style={{ width: "145px" }} />
      </div>
      <div className="h-[14px] mt-[14px]">
        <Skeleton style={{ width: "95%" }} />
      </div>
      <div className="h-[14px] mt-[12px]">
        <Skeleton style={{ width: "90%" }} />
      </div>
      <div className="h-[14px] mt-[12px]">
        <Skeleton style={{ width: "95%" }} />
      </div>
      <div className="h-[14px] mt-[12px]">
        <Skeleton style={{ width: "85%" }} />
      </div>
      <div className="h-[14px] mt-[12px]">
        <Skeleton style={{ width: "80%" }} />
      </div>
      <div className="h-[14px] mt-[20px]">
        <Skeleton style={{ width: "40%" }} />
      </div>
      <div className="flex justify-end h-[14px] mt-[12px]">
        <Skeleton style={{ width: "134px" }} />
      </div>
    </>
  );
}
